var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _g3, _path7, _path8, _g4, _path9, _path10, _g5, _path11, _path12, _g6, _path13, _path14, _g7, _path15, _path16, _g8, _path17, _path18, _g9, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNamuBusinessLogoWithName(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 39,
    viewBox: "0 0 120 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1232_1101",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 9,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7805 9.44638C14.4317 9.44638 10.0806 13.8268 10.0806 19.2128C10.0806 24.5949 14.4314 28.9788 19.7805 28.9788C25.1286 28.9788 29.4805 24.5949 29.4805 19.2128C29.4801 13.8268 25.1286 9.44638 19.7805 9.44638ZM18.8098 26.9632C15.1083 26.494 12.2104 23.3935 12.0287 19.588L18.8098 25.3155V26.9632ZM18.8097 22.7667L12.2704 17.2419C12.4792 16.4409 12.8139 15.6781 13.262 14.9821L18.8093 19.6661V22.7667H18.8097ZM18.8097 17.1181L14.5089 13.485C15.6942 12.3753 17.1991 11.6673 18.8097 11.4616V17.1181ZM20.7513 11.4618C22.3616 11.6678 23.8662 12.3758 25.0514 13.4852L20.7513 17.1183V11.4618ZM20.7513 19.6663L26.2987 14.9822C26.7471 15.678 27.0817 16.4409 27.2899 17.2421L20.7513 22.7669V19.6663ZM20.7513 26.9629V25.3148L27.5312 19.5874C27.3507 23.3932 24.4513 26.4937 20.7513 26.9629Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1232_1101)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1232_1101",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 122,
    height: 40
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.380493 -0.0533447H121.236V38.9807H0.380493V-0.0533447Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1232_1101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.32721 5.69562H33.2337V32.7315H6.32721V5.69562Z",
    fill: "#5D3DED"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1232_1101",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 5,
    width: 23,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2119 27.9252C30.3652 28.0225 30.536 28.0674 30.7035 28.0674C31.0269 28.0674 31.342 27.899 31.5207 27.5958C32.8679 25.3237 33.5788 22.7109 33.5788 20.0383C33.5788 11.983 27.168 5.43241 19.2873 5.43241C16.6764 5.43122 14.1168 6.15965 11.8952 7.53607C11.4446 7.81269 11.2988 8.41198 11.5729 8.87201C11.8459 9.33242 12.4315 9.48253 12.8809 9.20179C14.8062 8.00883 17.0246 7.3776 19.2873 7.37886C26.1173 7.37886 31.6736 13.0573 31.6736 20.0379C31.6736 22.3549 31.0563 24.6196 29.8896 26.5885C29.617 27.0459 29.7606 27.6482 30.2119 27.9252Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1232_1101)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1232_1101",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 121,
    height: 40
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.231995 0.693665H120.332V39.6227H0.231995V0.693665Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1232_1101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.70477 1.68866H37.3087V31.8108H7.70477V1.68866Z",
    fill: "#5D3DED"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1232_1101",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 11,
    width: 23,
    height: 24
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.76855 11.46C8.56058 11.3169 8.30392 11.2632 8.05603 11.3109C7.80815 11.3586 7.58975 11.5038 7.44976 11.7138C5.84879 14.0899 5.00116 16.8711 5.00116 19.7518C5.00116 27.6572 11.3903 34.089 19.2415 34.089C22.1045 34.089 24.867 33.2344 27.2279 31.6246C27.6619 31.3253 27.7743 30.7325 27.4799 30.2951C27.3388 30.0864 27.1205 29.9423 26.8732 29.8946C26.6258 29.8469 26.3696 29.8996 26.1611 30.0409C24.1234 31.4358 21.7109 32.1807 19.2415 32.1775C12.4368 32.1775 6.90051 26.604 6.90051 19.7526C6.90051 17.255 7.63468 14.8458 9.02162 12.7866C9.31638 12.35 9.20331 11.7574 8.76855 11.46Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1232_1101)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1232_1101",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 119,
    height: 39
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.369568 0.673676H118.987V38.9848H0.369568V0.673676Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1232_1101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.31738 7.61099H31.3275V37.7729H1.31738V7.61099Z",
    fill: "#5D3DED"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1232_1101",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 7,
    width: 31,
    height: 32
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0532 8.21938C34.9068 8.01164 34.6847 7.87183 34.4363 7.83099C34.1878 7.79016 33.9336 7.85169 33.7301 8.00191C33.3062 8.31837 33.2126 8.92223 33.5202 9.35549C38.4691 16.318 37.732 25.7973 31.7655 31.8936C25.7994 37.9867 16.522 38.7407 9.70534 33.6859C9.50254 33.5343 9.24828 33.4715 8.99951 33.5117C8.75074 33.5519 8.52824 33.6916 8.38184 33.8996C8.07417 34.3316 8.16793 34.9346 8.59171 35.2495C11.8208 37.6413 15.7155 38.9296 19.7132 38.9282C20.1817 38.9282 20.6525 38.9132 21.1225 38.8753C25.6409 38.5341 29.8981 36.5397 33.1067 33.2622C36.3177 29.975 38.2665 25.6322 38.6021 21.0162C38.9343 16.4496 37.6732 11.9052 35.0532 8.21938Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1232_1101)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1232_1101",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 40
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.716431 0.173004H119.691V39.1683H0.716431V0.173004Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1232_1101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.50598 4.06781H42.3491V42.678H4.50598V4.06781Z",
    fill: "#5D3DED"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_1232_1101",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.20928 31.2976C5.6417 30.9848 5.7375 30.3857 5.42375 29.9563C0.379861 23.0494 1.13127 13.6413 7.21154 7.59399C13.2914 1.54672 22.7455 0.79822 29.6912 5.81538C30.1228 6.12663 30.7264 6.03029 31.0399 5.60046C31.3526 5.17107 31.2575 4.57298 30.8266 4.2591C27.1376 1.59894 22.6109 0.323474 18.0571 0.661119C13.4527 1.00572 9.11518 2.9848 5.84558 6.23409C2.57275 9.49477 0.586688 13.8039 0.245628 18.3842C-0.0937061 22.9156 1.18976 27.4292 3.86057 31.0864C4.04206 31.3354 4.33372 31.4828 4.64422 31.4826C4.84791 31.4833 5.04628 31.4184 5.20928 31.2976Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_1232_1101)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_1232_1101",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 121,
    height: 40
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.192383 0.582336H120.928V39.1189H0.192383V0.582336Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_1232_1101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.55743 -3.09525H34.9733V35.1886H-3.55743V-3.09525Z",
    fill: "#5D3DED"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_1232_1101",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 10,
    width: 15,
    height: 14
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.8667 23.2179L74.7902 10.8393C74.6147 10.4698 74.2177 10.2307 73.7793 10.2274H73.2536C72.8163 10.231 72.4182 10.4701 72.2435 10.8393L66.168 23.2179H68.993L70.1818 20.7111H76.8365L78.041 23.2179H80.8667ZM71.1444 18.675L73.4861 13.7337L75.8591 18.675H71.1444Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_1232_1101)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_1232_1101",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 116,
    height: 38
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.63733 1.31161H117.49V38.9874H2.63733V1.31161Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_1232_1101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.6009 6.60379H84.4336V26.8404H62.6009V6.60379Z",
    fill: "#4D4E53"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_1232_1101",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 108,
    y: 10,
    width: 12,
    height: 14
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.444 10.535L117.432 19.7444C117.433 19.9953 117.333 20.2364 117.154 20.4147C116.974 20.593 116.73 20.6937 116.475 20.6948H112.023C111.768 20.6944 111.523 20.5939 111.343 20.4156C111.163 20.2373 111.063 19.9957 111.064 19.7444L111.053 10.535H108.496V20.0542C108.496 21.804 109.93 23.2255 111.692 23.2255H116.805C118.566 23.2255 120 21.804 120 20.0542V10.535H117.444Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_1232_1101)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_1232_1101",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 122,
    height: 40
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.530212 0.949707H120V39.2609H-0.530212V0.949707Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_1232_1101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.753 6.84921H123.743V26.9092H104.753V6.84921Z",
    fill: "#4D4E53"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_1232_1101",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 87,
    y: 10,
    width: 16,
    height: 14
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.3618 20.7095H95.2305C95.6696 20.7095 95.9947 20.459 96.2418 20.1054L99.9471 14.6313V23.2255H102.522L102.518 11.8022C102.518 11.1023 101.941 10.535 101.23 10.535H100.258C99.9257 10.535 99.6141 10.7269 99.4405 10.977L94.796 17.6999L90.1495 10.977C89.9748 10.7265 89.6651 10.535 89.3333 10.535H88.3599C87.6486 10.5362 87.0728 11.1034 87.0734 11.8022L87.0689 23.2255H89.6433V14.6313L93.3479 20.1054C93.5957 20.459 93.9208 20.7095 94.3618 20.7095Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_1232_1101)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask15_1232_1101",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 122,
    height: 40
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.142944 0.949707H120.592V39.2609H-0.142944V0.949707Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_1232_1101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.3197 6.84921H106.271V26.9092H83.3197L83.3197 6.84921Z",
    fill: "#4D4E53"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_1232_1101",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 10,
    width: 13,
    height: 14
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.3156 19.4202L51.2453 10.977C51.0383 10.7265 50.7716 10.535 50.4456 10.535H49.4937C48.7958 10.537 48.2317 11.1043 48.2335 11.8022L48.2291 23.2255H50.7506V14.3403L57.8197 22.7798C58.0268 23.034 58.295 23.2255 58.621 23.2255H59.5729C60.2676 23.2255 60.8331 22.6582 60.8331 21.9587L60.8368 10.535H58.3156V19.4202Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_1232_1101)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask17_1232_1101",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 119,
    height: 40
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.3703 0.949707H118.988V39.2609H0.3703V0.949707Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_1232_1101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.5452 6.84921H64.5208V26.9092H44.5452V6.84921Z",
    fill: "#4D4E53"
  })))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4999 32.0626C73.8305 32.1557 74.0853 32.3254 74.2641 32.5719C74.4484 32.8183 74.5405 33.1195 74.5405 33.4754C74.5405 33.9682 74.3644 34.3543 74.0121 34.6336C73.6652 34.9128 73.1856 35.0525 72.5731 35.0525H69.9716V29.2616H72.4918C73.088 29.2616 73.5541 29.3958 73.8902 29.6641C74.2316 29.927 74.4023 30.2966 74.4023 30.773C74.4023 31.0797 74.321 31.3452 74.1584 31.5698C74.0013 31.7943 73.7818 31.9586 73.4999 32.0626ZM70.996 31.7012H72.3211C73.042 31.7012 73.4024 31.4301 73.4024 30.888C73.4024 30.6142 73.3129 30.4116 73.1341 30.2802C72.9552 30.1487 72.6842 30.083 72.3211 30.083H70.996V31.7012ZM72.4593 34.2311C72.8387 34.2311 73.1151 34.1626 73.2886 34.0257C73.462 33.8888 73.5487 33.6753 73.5487 33.385C73.5487 33.0948 73.4593 32.8785 73.2804 32.7361C73.107 32.5938 72.8333 32.5226 72.4593 32.5226H70.996V34.2311H72.4593Z",
    fill: "#4D4E53"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3967 35.1264C78.6108 35.1264 78.0146 34.921 77.6082 34.5103C77.2017 34.0997 76.9984 33.5 76.9984 32.7115V29.2616H78.0228V32.769C78.0228 33.2673 78.1393 33.6451 78.3724 33.9025C78.6054 34.1544 78.9469 34.2804 79.3967 34.2804C79.8411 34.2804 80.1799 34.1517 80.4129 33.8943C80.646 33.6369 80.7625 33.2618 80.7625 32.769V29.2616H81.7868V32.7115C81.7868 33.4946 81.5836 34.0942 81.1771 34.5103C80.7706 34.921 80.1772 35.1264 79.3967 35.1264Z",
    fill: "#4D4E53"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4461 35.1264C86.0071 35.1264 85.5952 35.0662 85.2104 34.9457C84.8256 34.8252 84.5004 34.6555 84.2348 34.4364L84.5844 33.6643C84.8608 33.8779 85.1508 34.0339 85.4543 34.1325C85.7632 34.2311 86.0965 34.2804 86.4542 34.2804C86.8499 34.2804 87.1534 34.2119 87.3648 34.075C87.5816 33.9326 87.69 33.7355 87.69 33.4836C87.69 33.2646 87.5897 33.0976 87.3892 32.9826C87.1941 32.8676 86.8662 32.758 86.4055 32.654C85.9285 32.55 85.541 32.4295 85.2429 32.2926C84.9448 32.1557 84.7199 31.9805 84.5681 31.7669C84.4164 31.5533 84.3405 31.2823 84.3405 30.9537C84.3405 30.6142 84.4326 30.3103 84.6169 30.042C84.8012 29.7736 85.0613 29.5656 85.3974 29.4177C85.7334 29.2644 86.1209 29.1877 86.5599 29.1877C86.961 29.1877 87.3431 29.2507 87.7062 29.3766C88.0694 29.4971 88.3675 29.6641 88.6005 29.8777L88.2509 30.6498C87.7415 30.2391 87.1778 30.0338 86.5599 30.0338C86.1914 30.0338 85.8987 30.1104 85.6819 30.2637C85.4705 30.4116 85.3649 30.6197 85.3649 30.888C85.3649 31.1125 85.4597 31.285 85.6494 31.4055C85.8391 31.5259 86.1616 31.6382 86.6168 31.7423C87.0992 31.8518 87.4894 31.975 87.7875 32.1119C88.091 32.2433 88.3214 32.4131 88.4786 32.6211C88.6412 32.8292 88.7224 33.0921 88.7224 33.4097C88.7224 33.7547 88.6303 34.0586 88.446 34.3214C88.2672 34.5788 88.0043 34.7787 87.6574 34.921C87.316 35.0579 86.9122 35.1264 86.4461 35.1264Z",
    fill: "#4D4E53"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1972 29.2616H92.246V35.0525H91.1972V29.2616Z",
    fill: "#4D4E53"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8307 29.2616V35.0525H99.0421L95.9691 31.0112V35.0525H94.9935V29.2616H95.774L98.847 33.2947V29.2616H99.8307Z",
    fill: "#4D4E53"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M102.577 29.2616H106.414V30.0995H103.601V31.693H106.251V32.5226H103.601V34.2146H106.414V35.0525H102.577V29.2616Z",
    fill: "#4D4E53"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M110.738 35.1264C110.299 35.1264 109.887 35.0662 109.502 34.9457C109.117 34.8252 108.792 34.6555 108.526 34.4364L108.876 33.6643C109.152 33.8779 109.442 34.0339 109.746 34.1325C110.055 34.2311 110.388 34.2804 110.746 34.2804C111.141 34.2804 111.445 34.2119 111.656 34.075C111.873 33.9326 111.981 33.7355 111.981 33.4836C111.981 33.2646 111.881 33.0976 111.681 32.9826C111.486 32.8676 111.158 32.758 110.697 32.654C110.22 32.55 109.833 32.4295 109.534 32.2926C109.236 32.1557 109.011 31.9805 108.86 31.7669C108.708 31.5533 108.632 31.2823 108.632 30.9537C108.632 30.6142 108.724 30.3103 108.908 30.042C109.093 29.7736 109.353 29.5656 109.689 29.4177C110.025 29.2644 110.412 29.1877 110.851 29.1877C111.253 29.1877 111.635 29.2507 111.998 29.3766C112.361 29.4971 112.659 29.6641 112.892 29.8777L112.542 30.6498C112.033 30.2391 111.469 30.0338 110.851 30.0338C110.483 30.0338 110.19 30.1104 109.973 30.2637C109.762 30.4116 109.656 30.6197 109.656 30.888C109.656 31.1125 109.751 31.285 109.941 31.4055C110.131 31.5259 110.453 31.6382 110.908 31.7423C111.391 31.8518 111.781 31.975 112.079 32.1119C112.383 32.2433 112.613 32.4131 112.77 32.6211C112.933 32.8292 113.014 33.0921 113.014 33.4097C113.014 33.7547 112.922 34.0586 112.738 34.3214C112.559 34.5788 112.296 34.7787 111.949 34.921C111.608 35.0579 111.204 35.1264 110.738 35.1264Z",
    fill: "#4D4E53"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M117.432 35.1264C116.993 35.1264 116.581 35.0662 116.196 34.9457C115.811 34.8252 115.486 34.6555 115.22 34.4364L115.57 33.6643C115.846 33.8779 116.136 34.0339 116.44 34.1325C116.749 34.2311 117.082 34.2804 117.44 34.2804C117.836 34.2804 118.139 34.2119 118.35 34.075C118.567 33.9326 118.676 33.7355 118.676 33.4836C118.676 33.2646 118.575 33.0976 118.375 32.9826C118.18 32.8676 117.852 32.758 117.391 32.654C116.914 32.55 116.527 32.4295 116.229 32.2926C115.93 32.1557 115.706 31.9805 115.554 31.7669C115.402 31.5533 115.326 31.2823 115.326 30.9537C115.326 30.6142 115.418 30.3103 115.603 30.042C115.787 29.7736 116.047 29.5656 116.383 29.4177C116.719 29.2644 117.107 29.1877 117.546 29.1877C117.947 29.1877 118.329 29.2507 118.692 29.3766C119.055 29.4971 119.353 29.6641 119.586 29.8777L119.237 30.6498C118.727 30.2391 118.163 30.0338 117.546 30.0338C117.177 30.0338 116.884 30.1104 116.668 30.2637C116.456 30.4116 116.35 30.6197 116.35 30.888C116.35 31.1125 116.445 31.285 116.635 31.4055C116.825 31.5259 117.147 31.6382 117.602 31.7423C118.085 31.8518 118.475 31.975 118.773 32.1119C119.077 32.2433 119.307 32.4131 119.464 32.6211C119.627 32.8292 119.708 33.0921 119.708 33.4097C119.708 33.7547 119.616 34.0586 119.432 34.3214C119.253 34.5788 118.99 34.7787 118.643 34.921C118.302 35.0579 117.898 35.1264 117.432 35.1264Z",
    fill: "#4D4E53"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNamuBusinessLogoWithName);
export default __webpack_public_path__ + "static/media/namu-business-logo-with-name.dd2994f9b4c799c11b0560f3f3f40834.svg";
export { ForwardRef as ReactComponent };